<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
  @import '~styles/normalize.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue